export default "__VITE_ASSET__BHMbkuXV__"